import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { LiveIcon } from '../../icons';
import IconButton from '../IconButton';
import TooltipWrapper from '../TooltipWrapper';
import styles from './styles.module.scss';

export interface ILiveControlProps {
  active: boolean;
  className?: string;
  onClick: () => void;
}

const LiveControl = ({ active, className, onClick }: ILiveControlProps) => {
  const { t } = useTranslation('common');
  const text = t('aria_labels.controls.live');
  return (
    <TooltipWrapper tooltipText={active ? '' : text} tooltipPosition='top'>
      <IconButton
        disabled={active}
        aria-label={text}
        className={classNames(styles.liveControl, { [styles.active]: active }, className)}
        onClick={onClick}
        icon={
          <>
            <LiveIcon />
            {t('controls.live')}
          </>
        }
      />
    </TooltipWrapper>
  );
};

export default LiveControl;
